import React from "react";
import { useStyles } from "./style";
import moment from "moment";
import { useAppSelector } from "src/app-redux/hooks";
import { vehicleLevel4Data } from "src/app-redux/hq-dashboard/hqDashboardSlice";

export function VehicleLevel4Table(): React.ReactElement {
  const classes = useStyles();
  const rows: any = useAppSelector(vehicleLevel4Data);

  return (
    <>
      <table width="1601">
        <tbody>
          <tr className={classes.level4TableHead}>
            <td className={classes.level4Cells} width="79">
              &nbsp;
            </td>
            <td className={classes.level4Cells} width="53">
              &nbsp;
            </td>
            <td className={classes.level4Cells} colSpan={4} width="413">
              <p>
                <strong>Gate In</strong>
              </p>
            </td>
            <td className={classes.level4Cells} colSpan={3} width="387">
              <p>
                <strong>Weight</strong>
              </p>
            </td>
            <td className={classes.level4Cells} colSpan={4} width="335">
              <p>
                <strong>Scanning</strong>
              </p>
            </td>
            <td className={classes.level4Cells} colSpan={1} width="100">
              <p>
                <strong>Charges</strong>
              </p>
            </td>
            <td className={classes.level4Cells} colSpan={2} width="159">
              <p>
                <strong>Gate Out</strong>
              </p>
            </td>
          </tr>
          <tr className={`${classes.evenRow} ${classes.level4SubHeadings}`}>
            <td className={classes.level4Cells} width="79">
              <p>S.No.</p>
            </td>
            <td className={classes.level4Cells} width="53">
              <p>BT</p>
            </td>
            <td className={classes.level4Cells} width="100">
              <p>Date</p>
            </td>
            <td className={classes.level4Cells} width="90">
              <p>Time</p>
            </td>
            <td className={classes.level4Cells} width="123">
              <p>Vehicle Number</p>
            </td>
            <td className={classes.level4Cells} width="140">
              <p>Commodity</p>
            </td>
            <td className={classes.level4Cells} width="100">
              <p>Date</p>
            </td>
            <td className={classes.level4Cells} width="90">
              <p>Time</p>
            </td>
            <td className={classes.level4Cells} width="98">
              <p>Weight</p>
            </td>
            <td className={classes.level4Cells} width="100">
              <p>Date</p>
            </td>
            <td className={classes.level4Cells} width="90">
              <p>Time</p>
            </td>
            <td className={classes.level4Cells} width="97">
              <p>Results</p>
            </td>
            <td className={classes.level4Cells} width="87">
              <p>Image</p>
            </td>
            <td className={classes.level4Cells} width="100">
              <p>Total</p>
            </td>
            <td className={classes.level4Cells} width="100">
              <p>Date</p>
            </td>
            <td className={classes.level4Cells} width="100">
              <p>Time</p>
            </td>
          </tr>
          {rows?.map((obj: any, index: number) => {
            return (
              <tr key={index} className={index % 2 == 0 ? classes.oddRow : classes.evenRow}>
                <td className={classes.level4Cells} width="79">
                  <p>{index + 1}</p>
                </td>
                <td className={classes.level4Cells} width="53">
                  <p>{obj.terminalName ? obj.terminalName : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="100">
                  <p>
                    {obj.gateInDate ? moment(new Date(obj.gateInDate)).format("DD-MM-YYYY") : "-"}
                  </p>
                </td>
                <td className={classes.level4Cells} width="90">
                  <p>{obj.gateInDate ? moment(new Date(obj.gateInDate)).format("hh:mm A") : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="123">
                  <p>{obj.vehicleRegNumber ? obj.vehicleRegNumber : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="140">
                  <p>{obj.cargoTypeName ? obj.cargoTypeName : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="100">
                  <p>
                    {obj.weightDate ? moment(new Date(obj.weightDate)).format("DD-MM-YYYY") : "-"}
                  </p>
                </td>
                <td className={classes.level4Cells} width="90">
                  <p>{obj.weightDate ? moment(new Date(obj.weightDate)).format("hh:mm A") : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="98">
                  <p>{obj.weight ? `${obj.weight} KG` : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="100">
                  <p>{obj.scanDate ? moment(new Date(obj.scanDate)).format("DD-MM-YYYY") : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="90">
                  <p>{obj.scanDate ? moment(new Date(obj.scanDate)).format("hh:mm A") : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="97">
                  <p>{obj.anomly ? obj.anomly : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="87">
                  <p>-</p>
                </td>
                <td className={classes.level4Cells} width="96">
                  <p>{obj.charges ? `PKR ${obj.charges}` : "-"}</p>
                </td>
                <td className={classes.level4Cells} width="100">
                  <p>
                    {obj.gateOutDate ? moment(new Date(obj.gateOutDate)).format("DD-MM-YYYY") : "-"}
                  </p>
                </td>
                <td className={classes.level4Cells} width="100">
                  <p>
                    {obj.gateOutDate ? moment(new Date(obj.gateOutDate)).format("hh:mm A") : "-"}
                  </p>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}
